import { useThree } from "react-three-fiber";
import { min, max } from "d3";
import * as THREE from "three";
import { useSpring } from "@react-spring/core";

import {
  // formatTimeYear,
  CHART_DIMENSIONS,
} from "../../utils";

// Moves the camera about the z-axis
export const FocusOnMesh = ({
  width = CHART_DIMENSIONS.X.MAX - CHART_DIMENSIONS.X.MIN,
  zoomOnMesh = 1,
  springTransitionConfig = {},
}) => {
  const { camera } = useThree();

  // how far back do we need to be to capture the entire mesh?
  const fov = camera.fov; // this is the vertical FOV
  const hFovRad =
    2 * Math.atan(Math.tan(THREE.MathUtils.degToRad(fov / 2)) * camera.aspect);
  const meshWidth = width / zoomOnMesh;
  // const cameraZ0 = camera.position.z;

  // NB: If we are transitioning on a targeted orthographic camera,
  // fov will be undefined, and so will targetZ
  let targetZ = fov
    ? (meshWidth / 2 / Math.tan(hFovRad / 2)) * 1.2
    : camera.position.z;
  // console.log(fov, meshWidth, targetZ);

  const cameraTarget = [camera.position.x, camera.position.y, targetZ];

  useSpring({
    cameraPos: cameraTarget,
    onChange: (d) => {
      // TODO Why is this check necessary
      if (!d.cameraPos?.length) return;
      camera.position.set(...d.cameraPos);
      // TODO Not really sure if projection
      // matrix should be updated
      // camera.updateProjectionMatrix();
    },
    config: springTransitionConfig,
  });

  return null;
};

export const meshPositions = ({
  data = [],
  centerMeshAroundOrigin = true,
  translate = [0, 0, 0],
}) => {
  const x0 = min(data, (d) => d.x);
  const width = max(data, (d) => d.x) - x0 || CHART_DIMENSIONS.X.MAX;
  const position = [
    (centerMeshAroundOrigin ? -x0 - width / 2 : 0) + translate[0],
    translate[1],
    translate[2],
  ];

  return {
    x0,
    width,
    position,
  };
};
